import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './security/login/login.component';
import { CallingListComponent } from './component/calling-list/calling-list.component';
import { Customer360Component } from './component/customer360/customer360.component';
import { AuthGuardService as AuthGuard } from './core/authentication/authentication.guard';
import { InboundCallComponent } from './component/inbound-call/inbound-call.component';
import { ProfileComponent } from './component/profile/profile.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { ReportingComponent } from './component/reporting/reporting.component';
import { UamComponent } from './component/uam/uam.component';
import { PrsCallingListComponent } from './component/prs-calling-list/prs-calling-list.component';
import { PrsCustomer360Component } from './component/prs-customer360/prs-customer360.component';
import { PrsReportingComponent } from './component/prs-reporting/prs-reporting.component';
import { SoftOfferingsComponent } from './component/soft-offerings/soft-offerings.component';
import { SoftOfferingReportingComponent } from './component/soft-offering-reporting/soft-offering-reporting.component';
import { SoftCustomer360Component } from './component/soft-customer360/soft-customer360.component';
import { MarketShareReportingComponent } from './component/market-share-reporting/market-share-reporting.component';
import { CdmCallingListComponent } from './component/cdm-calling-list/cdm-calling-list.component';
import { CdmCustomer360Component } from './component/cdm-customer360/cdm-customer360.component';
import { LostCustomerComponent } from './component/lost-customer/lost-customer.component';
import { LostCustomer360Component } from './component/lost-customer360/lost-customer360.component';
import { LostCallingDialogComponent } from './modal/lost-calling-dialog/lost-calling-dialog.component';
import {WorkshopReassignmentComponent } from './component/workshop-reassignment/workshop-reassignment.component';
import { PrsDashboardComponent } from './component/prs-dashboard/prs-dashboard.component';
import { WorkshopManagerCallingListComponent } from './component/workshop-manager-calling-list/workshop-manager-calling-list.component';
import {PipelineManagementComponent} from './component/pipeline-management/pipeline-management.component';
import {PipelineSearchComponent} from './component/pipeline-search/pipeline-search.component';
import { DoorstepCallingListComponent } from './component/doorstep-calling-list/doorstep-calling-list.component';
import { DoorstepCustomer360Component } from './component/doorstep-customer360/doorstep-customer360.component';
import { DoorstepDashboardComponent } from './component/doorstep-dashboard/doorstep-dashboard.component';
import { AdminComponent } from './component/admin/admin.component';
import { TitanDealerDashboardComponent } from './component/titan-dealer-dashboard/titan-dealer-dashboard.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'titan-dealer-dashboard', component: TitanDealerDashboardComponent, canActivate: [AuthGuard] },
  { path: 'calling', component: CallingListComponent, canActivate: [AuthGuard] },
  { path: 'reporting', component: ReportingComponent, canActivate: [AuthGuard] },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'inboundCall', component: InboundCallComponent, canActivate: [AuthGuard] },
  { path: 'customer360', component: Customer360Component, canActivate: [AuthGuard] },
  { path: 'uam', component: UamComponent, canActivate: [AuthGuard] },
  { path: 'prs-calling', component: PrsCallingListComponent, canActivate: [AuthGuard] },
  { path: 'prs-customer360', component: PrsCustomer360Component, canActivate: [AuthGuard] },
  { path: 'prs-reporting', component: PrsReportingComponent, canActivate: [AuthGuard] },
  { path: 'soft-calling', component: SoftOfferingsComponent, canActivate: [AuthGuard] },
  { path: 'soft-reporting', component: SoftOfferingReportingComponent, canActivate: [AuthGuard] },
  { path: 'soft-customer360', component: SoftCustomer360Component, canActivate: [AuthGuard] },
  { path: 'market-reporting', component: MarketShareReportingComponent, canActivate: [AuthGuard] },
  { path: 'cdm-calling', component: CdmCallingListComponent, canActivate: [AuthGuard] },
  { path: 'cdm-customer360', component: CdmCustomer360Component, canActivate: [AuthGuard] },
  { path: 'lost-customer', component: LostCustomerComponent, canActivate: [AuthGuard] },
  { path: 'lost-calling-dialog', component: LostCallingDialogComponent, canActivate: [AuthGuard] },
  { path: 'lost-customer360', component: LostCustomer360Component, canActivate: [AuthGuard] },
  { path: 'workshop-reassignment',component: WorkshopReassignmentComponent, canActivate: [AuthGuard]},
  { path: 'prs-dashboard',component: PrsDashboardComponent, canActivate: [AuthGuard]},
  { path: 'workshop-manager-calling',component: WorkshopManagerCallingListComponent, canActivate: [AuthGuard]},
  {path:  'pipeline-search',component: PipelineSearchComponent, canActivate: [AuthGuard]},
  { path: 'pipeline-management',component: PipelineManagementComponent, canActivate: [AuthGuard] },
  {path:  'doorstep-calling-list',component: DoorstepCallingListComponent, canActivate: [AuthGuard]},
  {path:  'doorstep-customer360',component: DoorstepCustomer360Component, canActivate: [AuthGuard]},
  {path:  'doorstep-dashboard',component: DoorstepDashboardComponent, canActivate: [AuthGuard]},
  { path: 'admin', component:AdminComponent, canActivate: [AuthGuard]},

  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }